// extracted by mini-css-extract-plugin
module.exports = {"item":"TableCartPage_item__3y_xL","section":"TableCartPage_section__gYlfg","btn_container":"TableCartPage_btn_container__3oGWY"};